import { FC, useEffect, useState } from 'react';
import { Props } from './types';
import classes from './FileInput.module.scss';
import clsx from 'clsx';
import { MIME_TYPES } from '../../config/veriables';
import { FileThumbnail } from '../FileThumbnail';



export const FileInput: FC<Props> = ({ value, submitted, onChange }) => {
  const [drag, setDrag] = useState(false);
  const [error, setError] = useState('');
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (submitted) {
      setError(value.length ? '' : 'File required');
      return;
    }

    setError('');
  }, [value, submitted]);

  const validate = (input: File[]) => {
    const isTypeError = input.some((item) => !MIME_TYPES.includes(item.type.toLowerCase()));
    if (isTypeError) {
      setError('Wrong type');
      return false;
    }

    const isSizeError = input.some((item) => item.size > 10*1024*1024);
    if (isSizeError) {
      setError('Too large (10MB max)');
      return false;
    }

    return true;
  }

  return (
    <div
      className={clsx(classes.wrapper, { [classes.drag]: drag })}
      onDragEnter={() => setDrag(true)}
      onDragLeave={() => setDrag(false)}
      onDragEnd={() => setDrag(false)}
      onDragExit={() => setDrag(false)}
      onDrop={() => setDrag(false)}
    >
      {value.length ? (
        <FileThumbnail files={value} error={error} />
      ) : (
        <>
          <svg className={classes.icon} width="48" height="61" viewBox="0 0 48 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4256_348)">
              <path d="M24.1864 49.8333L24.1864 30.5M24.1864 30.5L14.5197 36.9444M24.1864 30.5L33.8531 36.9444M46.7426 20.8333H37.7204C34.1112 20.8333 32.3052 20.8332 30.9267 20.1308C29.7141 19.513 28.7289 18.5272 28.111 17.3146C27.4086 15.936 27.4086 14.1314 27.4086 10.5222V1.5M46.742 49.1889V21.8822C46.742 20.3059 46.7407 19.5177 46.5626 18.776C46.4047 18.1184 46.1449 17.4899 45.7915 16.9133C45.393 16.2629 44.8373 15.7056 43.7227 14.5911L33.6517 4.52005C32.5371 3.40548 31.9798 2.84825 31.3294 2.44971C30.7528 2.09637 30.1244 1.83593 29.4668 1.67806C28.7252 1.5 27.9367 1.5 26.3605 1.5H11.9426C8.33337 1.5 6.52741 1.5 5.14887 2.2024C3.93627 2.82025 2.95111 3.8062 2.33326 5.0188C1.63086 6.39734 1.63086 8.20192 1.63086 11.8112V49.1889C1.63086 52.7982 1.63086 54.6027 2.33326 55.9812C2.95111 57.1938 3.93627 58.1797 5.14887 58.7975C6.52741 59.4999 8.33337 59.5 11.9426 59.5H36.4315C40.0407 59.5 41.8441 59.4999 43.2226 58.7975C44.4352 58.1797 45.4224 57.1938 46.0403 55.9812C46.7427 54.6027 46.742 52.7982 46.742 49.1889Z" stroke="#DE1C72" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_4256_348">
                <rect width="48" height="60" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
            </defs>
          </svg>

          <div className={classes.text}>
            Drag & drop<br/>
            or <strong>Browse</strong> your receipt<br/>
            (JPEG or PNG)
            {error && (<div className={classes.error}>{error}</div>)}
          </div>
        </>
      )}

      <input
        key={counter}
        className={classes.fileInput}
        type="file"
        multiple
        onChange={({ target: { files } }) => {
          setCounter((input) => ++input)
          if (!files) {
            onChange([]);
            return;
          }

          const output: File[] = [];
          for (let i = 0; i < files.length; i++) {
            output.push(files.item(i) as File);
          }

          if (validate(output)) {
            onChange(output);
          }
        }}
      />
    </div>
  );
};
